import React, {useState, useEffect, useRef, useMemo} from 'react';
import { TouchableOpacity, Vibration, View, useWindowDimensions } from 'react-native'

import tw from '../../styles/tailwind';
import Text from '../../components/Text';

import { SafeAreaView } from 'react-native-safe-area-context';
import { useSelector } from 'react-redux';
import { Image } from 'expo-image';
import { Icon } from '../../components/Icon';
import { Illustration } from '../../components/Illustration';
import Mascara from './mascara.svg';
import { CameraView, CameraType, FlashMode, useCameraPermissions } from 'expo-camera';
import useRegisterForPushNotifications from '../../hooks/useRegisterPushNotifications';


import LottieView from 'lottie-react-native';
import api from '../../utils/api';
import IconButton from '../../components/IconButton';
import { setAdminCommunityId, setResidentCommunityId } from '../../store/Reducers/activeCommunity';
import useActiveAdminCommunity from '../../hooks/useActiveAdminCommunity';
import useStaff from '../../hooks/useStaff';



function QRResult({ scannedCode, onClear }){
  const [successMessage, setSuccessMessage] = useState(null);
  const [resultCode, setResultCode] = useState();
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const animationRef = useRef<LottieView>(null)



  useEffect(() => {
    validateCode()
  }, []);

  useEffect(() => {
    // animationRef.current?.play()
    animationRef.current?.play(0, 25);

    // Or set a specific startFrame and endFrame with:
    // 0-25 loading
    // 26 - 34 acceso
    // 35 - 42 error
  }, [])

  function validateCode(){
    const data = {
      code: scannedCode,
    }

    setIsLoading(true)
    setErrorMessage()
    setSuccessMessage()

    // https://ding-dong.mx/p/303f7f02-6f92-4586-9c37-65949397886b

    api.post(`/entry-passes/validate`, data)
    .then(({data}) => {
      setIsLoading(false)
      console.log("success", data);
      setSuccessMessage(data.message)
      setResultCode(data.code)

      animationRef.current?.play(26, 33);
    })
    .catch(({response}) => {
      setIsLoading(false)
      console.log("error", response.data);
      animationRef.current?.play(34, 42);

      setErrorMessage(response.data?.error?.message ?? "Error de red")
      setResultCode(response.data?.code ?? null)
    })
  }

  return (
    <View style={tw`absolute rounded-xl overflow-hidden bg-white items-center pt-8 pb-9 px-4`}>
      <LottieView
        autoPlay
        ref={animationRef}
        loop={isLoading}
        style={{
          width: 270,
          height: 270,
        }}
        source={require('./Secuencia_accesoBM.json')}
      />

      {/* <Text>{scannedCode}</Text> */}

      {
        successMessage &&
          <>
            <Text style={tw`font-bold text-primary text-2xl pt-2 pb-6 text-center`}>{successMessage}</Text>

            {
              resultCode &&
                <View style={tw`mb-8 items-center`}>
                  {
                    resultCode.type === "amenity" &&
                      <Text>{resultCode.name}</Text>
                  }

                  <Image style={tw`w-18 h-18 rounded-lg mb-2`} source={resultCode.community?.image_path} />
                  <Text>{resultCode.community?.name}</Text>
                </View>
            }
            <IconButton title={'Cerrar'} icon='close' onPress={onClear} />
          </>
      }

      {
        errorMessage &&
          <>
            <Text style={tw`font-bold text-red text-xl pt-2 pb-6 text-center`}>{errorMessage}</Text>
            <IconButton title={'Escanear de nuevo'} onPress={onClear} />
          </>
      }

    </View>
  )
}

export default function QRScannerScreen({navigation}) {
  const [scanned, setScanned] = useState(false);
  const [codeType, setCodeType] = useState();
  const [torchOn, setTorchOn] = useState(false);
  const [isFocused, setIsFocused] = useState(true);


  const { communities } = useSelector(state => state.status)
  const activeCommunities = useSelector(state => state.activeCommunity)
  const {setActiveCommunityId} = useActiveAdminCommunity()

  const { adminCommunities: admin_communities, guardCommunities: guard_communities } = useStaff()

  const { cameraStyle, contentStyle } = useFullScreenCameraStyle();

  const [permission, requestPermission] = useCameraPermissions();

  const { registerPushToken } = useRegisterForPushNotifications()
  
  useEffect(() => {
    // registerPushToken() //! se repite en resident dashboard
  }, []);


  useEffect(() => {
    navigation.addListener('focus', () => {
      setIsFocused(true)
    })
  
    navigation.addListener('blur', () => {
      setIsFocused(false)
    });
  }, []);

  

  useEffect(() => {
    requestPermission()
  }, []);

  const handleBarCodeScanned = ({ type, data }) => {
    setScanned(data);
    setCodeType(type)
    Vibration.vibrate()
  };


  return (
    <View style={tw`flex-1 flex bg-primary bg-[#510C76] bg-black`}>
      {
        isFocused &&
          <CameraView
            enableTorch={torchOn}
            onBarcodeScanned={scanned ? undefined : handleBarCodeScanned}
            barcodeScannerSettings={{
              barcodeTypes: ['qr'],
            }}
            onMountError={error => console.log({error})}
            style={tw.style(`absolute left-0 right-0 top-0 bottom-0`, cameraStyle)}
          ></CameraView>
      }

      {/* mascara */}
      <Mascara style={tw`absolute -top-20 bottom-0 -left-10 -right-10`}  />


      <SafeAreaView style={tw`flex-1 items-center justify-center`}>
        {
          (!permission) &&
          <Text>Solicitando permisos de cámara</Text>
        }

        {
          (permission?.granted === false) &&
          <Text>Sin acceso a la cámara</Text>
        }

        {
          (communities?.length > 0 && admin_communities?.length > 0) &&
            <>
              <TouchableOpacity 
                style={tw`absolute top-14 right-5 bg-primary/30 px-3 py-1 rounded z-10`}
                onPress={() => {
                  // dispatch(setAdminCommunityId(admin_communities[0].uuid))
                  setActiveCommunityId(admin_communities[0].uuid)
                  

                  navigation.navigate('Admin.Dashboard', {
                    screen: "Home",
                    params: {
                      communityId: admin_communities[0].uuid,
                    }
                  })
                }}
              >
                <Text style={tw`text-white`}>{admin_communities[0].name}</Text>
              </TouchableOpacity>
            </>
        }

        {
          ((communities?.length > 0 || admin_communities?.length > 0) && guard_communities?.length > 0) &&
            <TouchableOpacity
              style={tw`absolute top-24 right-5 bg-primary/30 px-3 py-1 rounded z-10`}
              onPress={() => {
                navigation.navigate('Guard.Stack', { communityId: guard_communities[0].uuid })
              }}
            >
              <Text style={tw`text-white`}>Guardia</Text>
            </TouchableOpacity>
        }


        <TouchableOpacity
          style={tw`absolute top-12 left-2.5 px-3 py-3`}
          onPress={() => setTorchOn(!torchOn)}
        >
          <Icon name="flash" variant={torchOn ? 'on' : 'off'} width={28} height={28} />
        </TouchableOpacity>

        <TouchableOpacity
          style={tw`absolute top-12 right-2.5 px-4 py-3 bg-white/15 rounded-full z-20`}
          onPress={() => navigation.goBack()}
        >
          <Text style={tw`text-white`}>Cerrar</Text>
        </TouchableOpacity>


        <View style={tw`items-center -mt-36`}>
          <Illustration name="logo" width={160} height={96} />


          <View style={tw`h-90 w-90  border-white`}></View>
        </View>


        {
          scanned &&
            <QRResult scannedCode={scanned} onClear={() => setScanned(null)} />
        }

      </SafeAreaView>
    </View>
  );
}


// https://snack.expo.dev/@bycedric/expo-camera-fullscreen-cover-workaround?platform=android
/**
 * Calculate the width and height of a full screen camera.
 * This approach emulates a `cover` resize mode.
 * Because the `<Camera>` is also a wrapping element, 
 * we also need to calculate the offset back for the content.
 * 
 * @see https://reactnative.dev/docs/image#resizemode
 * @see https://github.com/react-native-camera/react-native-camera/issues/1267#issuecomment-376937499
 */
export function useFullScreenCameraStyle(ratio = 3 / 4) {
  const window = useWindowDimensions();
  const isPortrait = window.height >= window.width;
  let cameraStyle, contentStyle;

  if (isPortrait) {
    // If the device is in portrait mode, we need to increase the width and move it out of the screen
    const widthByRatio = window.height * ratio;
    const widthOffsetByRatio = -((widthByRatio - window.width) / 2);

    // The camera is scaled up to "cover" the full screen, while maintainin ratio
    cameraStyle = { left: widthOffsetByRatio, right: widthOffsetByRatio };
    // But because the camera is also a wrapping element, we need to reverse this offset to align the content
    contentStyle = { left: -widthOffsetByRatio, right: -widthOffsetByRatio };
  } else {
    // If the device is in landscape mode, we need to increase the height and move it out of the screen
    const heightByRatio = window.width * ratio;
    const heightOffsetByRatio = -((heightByRatio - window.height) / 2);

    // See portrait comments
    cameraStyle = { top: heightOffsetByRatio, bottom: heightOffsetByRatio };
    contentStyle = { top: -heightOffsetByRatio, bottom: -heightOffsetByRatio };
  }

  return { cameraStyle, contentStyle };
}